import { createRootRoute, Outlet, retainSearchParams } from "@tanstack/react-router";
import { zodValidator } from "@tanstack/zod-adapter";
import { EmbedMeta } from "../shared/components/embed-meta";
import { NotFoundPage } from "../shared/components/not-found-page";
import { RouterErrorComponent } from "../shared/components/router-error-component";
import { globalLoader } from "../shared/utils/global-loaders";
import { monitorQueryParameters } from "../shared/utils/query-param-security";
import { rootSearchSchema } from "../shared/utils/search-params-schema";

function RootNotFoundPage() {
  return <NotFoundPage fullHeight />;
}

export const Route = createRootRoute({
  loader: globalLoader,
  validateSearch: zodValidator(rootSearchSchema),
  search: {
    middlewares: [retainSearchParams(true)],
  },
  component: RootComponent,
  notFoundComponent: RootNotFoundPage,
  errorComponent: ({ error, reset }) => {
    return <RouterErrorComponent error={error} reset={reset} />;
  },
  beforeLoad: () => {
    // Monitor for suspicious query parameters on every route navigation
    monitorQueryParameters();
  },
});

function RootComponent() {
  return (
    <>
      <EmbedMeta />
      <Outlet />
    </>
  );
}
